import React from 'react';
import { wrapFnComponent } from '../components/Wrappers';
import { triggerToast } from '../components/Toast/misc';

const progressMsgChannel = ({
	maxProgressMsgs = 8,
	initMsg = 'Starting progress...',
} = {}) => {
	let progresses = [{ msg: initMsg }];
	const ui = {};
	const msgChannel = {
		progress: (settings) => {
			progresses.push(settings);
			if (progresses.length > maxProgressMsgs) {
				progresses = [{ msg: '...' }, ...progresses.slice(-maxProgressMsgs)];
			}
			ui.box?.update();
		},
		onChannelClosed({ error }) {
			this.progress(error ? { msg: 'Failed...', isError: true } : { msg: 'Done' });
			setTimeout(() => ui.close?.(), 5000);
		},
	};
	const render = () => ( // Renders the list inside the <Toast>
		<>
			{progresses.map(({ msg, isError }, idx) => (
				<div
					style={isError && { fontWeight: 'bold', color: 'red' }}
					key={idx.toString()}
				>
					{msg}
				</div>
			))}
		</>
	);
	const Renderer = wrapFnComponent((p, box) => Object.assign(ui, p, { box }) && render());
	triggerToast({
		message: (p) => <Renderer {...p} />,
		status: 'info',
	});
	return msgChannel;
};

export default progressMsgChannel;
